
const formatFecha = (fecha) => {
    const dia = String(fecha.getDate()).padStart(2, '0'); // Obtiene el día y lo formatea con dos dígitos
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Obtiene el mes y lo formatea con dos dígitos (los meses empiezan en 0)
    const año = fecha.getFullYear(); // Obtiene el año
  
    return `${dia}-${mes}-${año}`; // Combina los valores en el formato deseado
  };

async function getSignedUploadURL(token, apiUrl, filePath, fileName) {
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`, // Token de autorización
      },
      body: JSON.stringify({
        path: filePath,
        image_name: fileName,
      }),
    });

    if (!response.ok) {
      throw new Error("Error obteniendo la URL firmada");
    }

    const data = await response.json();
    console.log("Respuesta de la API:", data);

    return data; // Contiene la URL firmada y otros datos
  } catch (error) {
    console.error("Error:", error);
  }
}


async function uploadFileToS3(uploadURL, file) {
  try {
    const blob = file.uri.startsWith('data:') ? dataURItoBlob(file.uri) : file;

    const response = await fetch(uploadURL, {
      method: "PUT",
      headers: {
        "Content-Type": blob.type || 'application/octet-stream', // Asegúrate de usar el tipo MIME correcto
      },
      body: blob, // Aquí envías el archivo real
    });

    if (!response.ok) {
      throw new Error("Error subiendo el archivo a S3");
    }

    console.log("Archivo subido exitosamente");
  } catch (error) {
    console.error("Error al subir el archivo:", error);
  }
}

function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
}

//Usaria esta como principal
//Sacar la subida de s3 de aca y que lo haga esta funcion
//Borrar credenciales
async function handleFileUpload(file, token, apiUrl, filePath, nameFile) {
  try {
    // Paso 1: Obtener la URL firmada desde tu API
    const { uploadURL } = await getSignedUploadURL(token, apiUrl, filePath, nameFile);

    console.log("Subiendo archivo...");
    // Paso 2: Subir el archivo a S3 usando la URL firmada
    await uploadFileToS3(uploadURL, file);

    console.log("Archivo subido correctamente a:", uploadURL );
  } catch (error) {
    console.error("Error en el proceso de subida:", error);
  }
}

export { handleFileUpload, formatFecha }